import SofortPayment from "./SofortPayment";
export default SofortPayment;
